import { useContext, useEffect, useState } from 'react'
import { format, isBefore } from 'date-fns'
import { useParams } from 'react-router-dom'
import Card from '../../../../../components/Card'
import { Container } from './styles'
import { api, authHeaders } from '../../../../../services/api'
import { GlobalContext } from '../../../../../contexts/GlobalContext'
import { Button } from '../../../../../components/Form'
import { FiCheck, FiX } from 'react-icons/fi'
import { FaExclamationTriangle } from 'react-icons/fa'
import { toast } from 'react-toastify'

export function AceiteParticipacao({ onAceitar }) {
	const { id } = useParams()

	const { user, checkException } = useContext(GlobalContext)

	const [projeto, setProjeto] = useState(null)
	const [isProcessingAccept, setIsProcessingAccept] = useState(false)
	const [isProcessingReject, setIsProcessingReject] = useState(false)
	const [wasRejected, setWasRejected] = useState(false)

	async function loadProjeto() {
		const response = await api.get(`projeto/${id}`, authHeaders())

		setProjeto(response)
	}

	async function handleResponderConvite(resposta) {
		try {
			if(resposta === 1) {
				setIsProcessingAccept(true)
			} else {
				setIsProcessingReject(true)
			}

			await api.patch(`projeto/${projeto.id}/aceite_participacao/${user.pessoa.id}/${resposta}`, {}, authHeaders())

			if(resposta === 1) {
				toast.success('Seja bem-vindo ao projeto!')

				onAceitar()
			} else {
				setWasRejected(true)

				toast.success('Sua resposta foi registrada. Obrigado!')
			}
		} catch(e) {
			checkException(e)
		} finally {
			setIsProcessingAccept(false)
			setIsProcessingReject(false)
		}
	}

	useEffect(() => {
		loadProjeto()
	}, [])

	if(!projeto) {
		return (
			<div className="h-[50vh]"></div>
		)
	}

	if(wasRejected) {
		return (
			<Container>
				<Card className="flex flex-col gap-4">
					<h1>Aceite de participação no projeto {projeto.nome}</h1>

					<p>Agradecemos por sua resposta. Obrigado!</p>
				</Card>
			</Container>
		)
	}

	const { funcao, expiracao_aceite } = projeto.projeto_pessoas.find(proj_pessoa => proj_pessoa.pessoa.id === user.pessoa.id)
	const conviteExpirado = isBefore(new Date(expiracao_aceite), new Date())

	return (
		<Container>
			<Card className="flex flex-col gap-4">
				<h1>Aceite de participação no projeto {projeto.nome}</h1>

				{!conviteExpirado ? (
					<>
						<p>Você foi convidado(a) por <b className="font-bold">{projeto.autor.nome}</b> para ser <b className="font-bold">{funcao.descricao}</b> no projeto <b className="font-bold">{projeto.nome}</b>.</p>

						<div className="grid grid-cols-[80px_auto]">
							<p className="font-semibold">Descrição:</p>
							<p>{projeto.descricao}</p>
						</div>

						<div className="grid grid-cols-[80px_auto]">
							<p className="font-semibold">Objetivo:</p>
							<p>{projeto.objetivo}</p>
						</div>

						<p>Informe se deseja fazer parte do projeto clicando em uma das opções abaixo:</p>

						<div className="flex gap-2 w-full justify-center">
							<Button onClick={() => { handleResponderConvite(0) }} className="red" loading={isProcessingReject}>
								Não desejo participar
								<FiX size={16} />
							</Button>

							<Button onClick={() => { handleResponderConvite(1) }} className="green" loading={isProcessingAccept}>
								Confirmo minha participação
								<FiCheck size={16} />
							</Button>
						</div>

						<p>Você tem até o dia {format(new Date(expiracao_aceite), 'dd/MM/yyyy')} para se manifestar.</p>
					</>
				) : (
					<p className="bg-yellow-500 px-4 py-3 rounded-md text-slate-800 self-center w-fit flex gap-2 items-center mt-8 mb-16">
						<FaExclamationTriangle size={16} />
						Este convite está expirado.
					</p>
				)}
			</Card>
		</Container>
	)
}